import { render, staticRenderFns } from "./AppLogo.vue?vue&type=template&id=051f153e&scoped=true&"
import script from "./AppLogo.vue?vue&type=script&lang=js&"
export * from "./AppLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051f153e",
  null
  
)

export default component.exports